"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const getDefaultState = ({ numberOfSteps = 0, zeroBasedIndex = true }) => ({
    completedSteps: new Set([]),
    activeStep: zeroBasedIndex ? 0 : 1,
    isFirstStep: true,
    isLastStep: false,
    numberOfSteps
});
const stepperReducer = (state, action) => {
    switch (action.type) {
        case 'STEP_COMPLETE':
            return Object.assign(Object.assign({}, state), { completedSteps: state.completedSteps.add(action.payload) });
        case 'STEP_INCOMPLETE':
            state.completedSteps.delete(action.payload);
            return Object.assign(Object.assign({}, state), { completedSteps: state.completedSteps });
        case 'SET_ACTIVE_STEP_COMPLETE_AND_SET_STEP':
            return Object.assign(Object.assign({}, state), { activeStep: action.payload, completedSteps: state.completedSteps.add(state.activeStep) });
        case 'SET_ACTIVE_STEP_INCOMPLETE_AND_SET_STEP': {
            state.completedSteps.delete(action.payload);
            return Object.assign(Object.assign({}, state), { activeStep: action.payload, completedSteps: state.completedSteps });
        }
        case 'SET_ACTIVE_STEP':
            return Object.assign(Object.assign({}, state), { activeStep: action.payload });
        case 'SET_NUMBER_OF_STEPS':
            return Object.assign(Object.assign({}, state), { numberOfSteps: action.payload });
        case 'REFRESH':
            return getDefaultState({ numberOfSteps: 0 });
        default:
            return getDefaultState({ numberOfSteps: state.numberOfSteps });
    }
};
const useStepper = ({ numberOfSteps = 0, zeroBasedIndex = true } = {}) => {
    const [state, dispatch] = react_1.useReducer(stepperReducer, getDefaultState({ numberOfSteps, zeroBasedIndex }));
    const onStepComplete = react_1.useCallback((step) => dispatch({ type: 'STEP_COMPLETE', payload: step }), [dispatch]);
    const onStepIncomplete = react_1.useCallback((step) => dispatch({ type: 'STEP_INCOMPLETE', payload: step }), [dispatch]);
    const completeActiveStepAndSetNewActiveStep = react_1.useCallback((newActiveStep) => dispatch({
        type: 'SET_ACTIVE_STEP_COMPLETE_AND_SET_STEP',
        payload: newActiveStep
    }), [dispatch]);
    const incompleteActiveStepAndSetStep = react_1.useCallback((newActiveStep) => dispatch({
        type: 'SET_ACTIVE_STEP_INCOMPLETE_AND_SET_STEP',
        payload: newActiveStep
    }), [dispatch]);
    const setActiveStep = react_1.useCallback((step) => dispatch({ type: 'SET_ACTIVE_STEP', payload: step }), [dispatch]);
    const setNumberOfSteps = react_1.useCallback((numOfSteps) => dispatch({ type: 'SET_NUMBER_OF_STEPS', payload: numOfSteps }), [dispatch]);
    const isStepComplete = react_1.useCallback((step) => { var _a; return Array.from((_a = state.completedSteps) !== null && _a !== void 0 ? _a : []).some(x => x === step); }, [dispatch]);
    const refresh = react_1.useCallback(() => dispatch({ type: 'REFRESH' }), [dispatch]);
    return [
        Object.assign(Object.assign(Object.assign({}, state), { isFirstStep: react_1.useMemo(() => state.activeStep === 1, [state.activeStep]), isStepComplete, completedSteps: Array.from(state.completedSteps) }), (numberOfSteps && { isLastStep: state.activeStep === numberOfSteps })),
        {
            onStepComplete,
            onStepIncomplete,
            completeActiveStepAndSetNewActiveStep,
            incompleteActiveStepAndSetStep,
            setActiveStep,
            setNumberOfSteps,
            refresh
        }
    ];
};
exports.default = useStepper;
